<button mat-icon-button color="primary" [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger" matTooltip="Search"
	(click)="openMenu()" matTooltip="Search">
	<mat-icon>search</mat-icon>
</button>

<mat-menu class="padding-horizontal-sm" #menu="matMenu">
	<span (click)="$event.stopPropagation()">
		<h2>Filters</h2>


		<div class="icon-text" *ngFor="let filter of filters | keyvalue | orderBy: 'value.index'">
			<mat-checkbox [disabled]="!filter.value.enabled" [color]="'primary'" class="checkbox-margin"
				[(ngModel)]="filter.value.checked">
			</mat-checkbox>
			{{filter.key}}
		</div>

		<hr />
		<div class="row">
			<button mat-raised-button (click)="confirm('selected')" #confirmElement tabindex="1000">Match from selected
				children</button>
			<button mat-raised-button (click)="confirm('all')" tabindex="1001">Match with all children in
				system</button>
		</div>
	</span>
</mat-menu>